<template>
  <div v-if="element" :class="`element-wrapper ${element.compData.type}-theme-${element.compData.styleId}`"
    :style="{...getStyles(element.compData.styles),
    width: element.width + 'px',
    height: element.height + 'px',}">
   <div class="video-container" v-if="element.compData.videoType === 'other' && showVideo">
        <video-player v-if="element.compData.playerOptions.sources.src" class="video-player-box"
          ref="videoPlayer"
          :options="element.compData.playerOptions"
          :playsinline="true"
          customEventName="customstatechangedeventname"
          @ready="playerReadied"
          style="object-fit:fill">
        </video-player>
        <div v-else class="video-com-pic">
          请添加视频地址
        </div>
    </div>
    <div v-else style="width: 100%;height:100%">
      <!-- <video style="width: 100%;height:100%" ref="player" muted autoplay></video> -->
      <video style="width: 100%;height:100%" ref="player" controls controlsList='nodownload' disablePictureInPicture autoplay></video>
    </div>
  </div>
</template>

<script>
import 'video.js/dist/video-js.css'
import appConst from "@/util/editorConst";
/**
 * @example https://docs.videojs.com/tutorial-options.html
 * @description https://github.com/surmon-china/vue-video-player#readme
 */
import { videoPlayer } from 'vue-video-player'
import flvjs from "flv.js";
import { handleRepairePublicPrefix } from '@/util'
export default {
  name: 'CompVideos',
  props: {
    element: {
      type: Object,
      default: null,
      require: true,
      handleRepairePublicPrefix
    }
  },
  data: () => {
    return {
      loading: true,
      playerWs: null,
      showVideo: true,
    }
  },
  mounted () {
    setTimeout(() => {
      this.loading = false
    }, 1234)
    if (this.videoType === 'rtsp' || this.videoType === 'rtmp' || this.videoType === 'flv') {
      this.showVideo = false
      this.initVideo()
    }
  },
  computed: {
    plugin: function() {
      return this.$getPlugin(this.element.id)
    },
    videoType() {
      return this.element && this.element.compData && this.element.compData.videoType
    }
  },
  components: {
    videoPlayer
  },
  methods: {
    initVideo() {
      this.destoryPlayer()
      if (flvjs.isSupported()) {
            let video = this.$refs.player;
            if (video) {
              this.playerWs = flvjs.createPlayer({
                  type: "flv",
                  isLive: true,
                  // url: `${appConst.WS_SERVER}${this.element.id}/?url=${this.element.compData.playerOptions.sources.src}&type=${this.element.compData.videoType}`
                  url: `${appConst.WS_SERVER}${this.element.id}/?url=${encodeURIComponent(this.element.compData.playerOptions.sources.src)}&type=${this.element.compData.videoType}`
              });
              if (this.playerWs) {

                this.playerWs.attachMediaElement(video);
                try {
                    this.playerWs.load();
                    this.playerWs.play();
                } catch (error) {
                    // console.log(error);
                };
              } else {

              }
            }
        }
    },
    // 视频初始化完成
    playerReadied(player) {
      console.log('the player is readied', player)
      // player.autoplay('muted');
      // you can use it to do something...
      // player.[methods]
      // 初始化完成蓝图事件触发trigger
      this.$blueMap.trigger({
        nodeType: 'plugin',
        pluginId: this.plugin.id,
        dataKey: 'onmounted',
        eventData: {
          value: null,
          data: this.plugin,
          event: null
        }
      })
    },
    getStyles (styles) {
      if (!styles) return
      const res = {}
      Object.keys(styles).forEach((item) => {
        res[`--${item}`] = (typeof styles[item] === 'number') ? styles[item] + 'px' : styles[item]
      })
      return res
    },
    destoryPlayer() {
      if (this.playerWs) this.playerWs.destory && this.playerWs.destory(), this.playerWs.unload && this.playerWs.unload(), this.playerWs.pause && this.playerWs.pause();
    }
  },
  beforeDestroy () {
    this.destoryPlayer();
  },
}
</script>

<style lang='less' scoped>
.element-wrapper {
  width: 100%;
  height: 100%;
}
.video-container{
  width: 100%;
  height:100%;
    .video-com-pic{
      width: 100%;
      height: 100%;
      background-color: #000;
      font-size: 24px;
      color: #fff;
      text-align: center;
  }
}
.video-player-box{
  width: 100%;
  height: 100%;
}
/deep/.video-js{
  width:100% !important;
  height:100% !important;
  .vjs-big-play-button{
    width:2em;
    height: 1.6em;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border:none;
  }
}
.vjs_video_3-dimensions{
  width:100% !important;
  height:100% !important;
}
</style>
